{
    "webshop_offer_voucher_correctCode": "Codice immesso corretto",
    "webShop_howToFindId_desc": "Puoi trovare e copiare il tuo ID personale nel tuo profilo giocatore.",
    "webShop_howToFindId_link": "Dove trovo il mio ID personale?",
    "webshop_offer_voucher_codeIsIncorrect": "Il codice è errato",
    "webshop_offer_voucher_enterYourCode": "Immetti il tuo ID personale",
    "webShop_unexpectedError_desc": "Si è verificato un errore imprevisto, riprova più tardi.",
    "webShop_accountBanned_desc": "Account bannato!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Termini e condizioni",
    "webshop_purchase_privacyPolicy": "Privacy",
    "webshop_legal_1": "Legale",
    "webshop_support_1": "Assistenza",
    "mbs_access_welcome_desc": "Ciao, {0}",
    "btn_login": "Accedi",
    "mbs_access_error_sessionExpired_desc": "La tua sessione è scaduta. Immetti manualmente il tuo ID account."
}
